<template>
  <div class="master-filter app-filter hideLandscape">
    <div class="app-filter-label">{{ label }}</div>
    <div class="app-filter-select">
      <b-dropdown
        ref="dropdown-filters"
        variant="link"
        toggle-class="app-filter-toggle"
        menu-class="app-filter-menu app-filter-menu--employees"
        no-caret
      >
        <template #button-content>
          <div class="app-filter-trigger">
            <span>{{ active.name }}</span>
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </template>
        <b-dropdown-item
          class="app-filter-item"
          link-class="app-filter-option-link"
          :class="{'active-filter': active.id === item.id}"
          href="#"
          v-for="(item, key) in dropdownOptions"
          :key="key"
          @click="filterBroker(item)"
        >
          <div class="app-filter-option">
            <span v-if="item.id" class="app-filter-avatar">
              <img v-if="item.profile_image" :src="item.profile_image" alt=""/>
              <span v-else>{{ initials(item.name) }}</span>
            </span>
            <span class="app-filter-option-label">{{ item.name }}</span>
            <span v-if="active.id === item.id" class="app-filter-check">✓</span>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterByEmployee",
  props: {
    employees: Array,
    label: String,
  },
  computed: {
    dropdownOptions() {
      const options = [];
      const seenIds = new Set();

      options.push({name: "Všetko", id: null});

      for (let i = 0; i < this.employees.length; i++) {
        const employee = this.employees[i];

        if (employee.role === "alex_admin")
          continue;

        if (seenIds.has(employee.id))
          continue;
        seenIds.add(employee.id);

        const name = employee.first_name + " " + employee.last_name;
        const id = employee.id;
        options.push({name: name, id: id, profile_image: employee.profile_image});
      }

      return options;
    }
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      this.active = this.defaultValue;
    },
    filterBroker (item) {
      this.active = item;
      this.$emit("employee-filter-change", item.id);
    },
    initials(name) {
      return String(name)
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0])
        .join("")
        .toUpperCase();
    },
  },
  data: () => ({
    defaultValue: {name: "Všetko", id: null},
    active: null
  }),
}
</script>

<style lang="scss" scoped></style>
